<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/136s6yT/tc-custom/FC-9781528971638.jpg?1685327667292?1725650079268" alt="This image is the cover for the book Survived, Endured and Beaten Cancer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Survived, Endured and Beaten Cancer
      </h1>
      <p class="bookDescription body article font2">
        <p>The story of how the author's life with bowel cancer first began, after the diagnosis and operation, how he coped with many years of pain due to abdominal adhesions plus the twisted colon at a later stage, how he overcame it and eventually beat it altogether and became pain free. It is also a reminder to cancer survivors and sufferers that at any stage of cancer and in whatever pain they are in, they must not give in to it or become negative or pessimistic. It brings hope, positivity, encouragement, confidence, inspiration and optimism to all who are struggling to cope with cancer and the aftereffects. The author also explains how big the difference in being alive, living and having his life saved is compared to not having his life saved and being dead. The excitement of the author has been there right from the beginning because to him it is a miracle. This is also education as well and may help people when reacting to an initial diagnosis, how to exercise while in pain, how not to eat and drink certain things when given advice by a professional and how to adapt to living while in pain. It also says that anyone affected by cancer should be strong-willed, believe in themselves and try as hard as possible to find a solution when they are going through hard times. It may also be of a big help to medical professionals plus anyone studying cancer and similar related conditions.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter King
      </h2>
      
      <p class="authorDescription body article">Very positive, always trying to find a solution to a problem even when in a lot of pain and not one for worrying either. Likes passing on positive experiences on to others. Always looks on the bright side of life and never gives in to anything. Strong-willed as well.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4fbadd71